module.exports = __webpack_public_path__ + "img/store.121ba239.svg";